import { useEffect, useState } from "react";

interface Props {
  endsAt: number;
  variant?: "light" | "dark";
  label?: string;
}

export function BigTimer({ endsAt, variant = "light", label }: Props) {
  const [remaining, setRemaining] = useState(() =>
    Math.max(0, Math.round((endsAt - Date.now()) / 1000)),
  );

  useEffect(() => {
    // Reset immediately on endsAt change so we never show a stale 1s
    // remainder from the previous timer (mirrors ParticipantTimerBar).
    setRemaining(Math.max(0, Math.round((endsAt - Date.now()) / 1000)));
    const id = setInterval(() => {
      setRemaining(Math.max(0, Math.round((endsAt - Date.now()) / 1000)));
    }, 1000);
    return () => clearInterval(id);
  }, [endsAt]);

  const mm = String(Math.floor(remaining / 60)).padStart(2, "0");
  const ss = String(remaining % 60).padStart(2, "0");
  const urgent = remaining > 0 && remaining <= 60;
  const expired = remaining === 0;

  const isDark = variant === "dark";
  const color = expired
    ? "#c53030"
    : urgent
      ? "#F59E0B"
      : isDark
        ? "#fff"
        : "var(--color-svo-dunkelblau, #001E62)";

  return (
    <div
      style={{
        display: "grid",
        placeItems: "center",
        gap: "0.5rem",
        color,
      }}
    >
      {label && (
        <div
          style={{
            fontSize: 14,
            letterSpacing: 2,
            textTransform: "uppercase",
            opacity: 0.75,
          }}
        >
          {label}
        </div>
      )}
      <div
        style={{
          fontSize: "clamp(4rem, 12vw, 10rem)",
          fontWeight: 700,
          fontVariantNumeric: "tabular-nums",
          letterSpacing: "-0.04em",
          lineHeight: 1,
        }}
      >
        {mm}:{ss}
      </div>
      {expired && (
        <div style={{ fontSize: 18, fontWeight: 600 }}>Zeit ist um.</div>
      )}
    </div>
  );
}
